/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum ApplicationErrorDataKey {
  /**
   * Application error code
   */
  APP_ERROR = 'error',
  /**
   * Application error code
   */
  APP_ERROR_CODE = 'error_code',
  /**
   * Application error message
   */
  APP_ERROR_MESSAGE = 'error_message',
  /**
   * Application error description
   */
  APP_ERROR_DESCRIPTION = 'error_description',
  /**
   * Application internal error
   */
  APP_ERROR_INTERNAL = 'error_internal',
  /**
   * Application error type
   */
  APP_ERROR_TYPE = 'error_type',
  /**
   * Application error severity
   */
  APP_ERROR_SEVERITY = 'error_severity',
}
